module.exports = __webpack_public_path__ + "img/yuannei1.f4a21a4a.png";